import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-shared-pill',
  templateUrl: './shared-pill.component.html',
  styleUrls: ['./shared-pill.component.scss'],
})
export class SharedPillComponent {
  @Input() content?: string;
  @Input() content_class?: string;
  @Input() pill_class?: string;
  @Input() is_clear_enabled: boolean = false;
  @Input() clear_icon_class: string = 'sp-color__accent-contrast';
  @Input() is_icon_enabled: boolean = false;
  @Input() icon?: string;
  @Input() icon_class: string = 'sp-color__accent-contrast';
  @Input() is_large_text_enabled: boolean = false;
  @Output() clear_click: EventEmitter<void> = new EventEmitter<void>();
}
